import comp from "./MediaQuestionSubmissionMethod";
export default comp;
